/**
 * routeProgress — tiny global helper that drives the top progress bar.
 *
 * Two modes:
 *   • Determinate (CSS `body.route-loading`)   — flashes 0→90% then fades.
 *     Used by Layout's pathname-change effect and the Acil Bildir click
 *     handler. Auto-clears after a fixed timeout.
 *   • Indeterminate (CSS `body.route-loading-indet`) — animated stripe
 *     that loops while any API request is in flight. Refcounted so it
 *     stays on until the LAST request resolves.
 *
 * Kept dependency-free so it can be imported by both axios interceptors
 * and any React component without circular issues.
 */

let inflight = 0;

export function startIndeterminate() {
  if (typeof document === "undefined") return;
  inflight += 1;
  if (inflight === 1) {
    document.body.classList.add("route-loading-indet");
  }
}

export function stopIndeterminate() {
  if (typeof document === "undefined") return;
  inflight = Math.max(0, inflight - 1);
  if (inflight === 0) {
    document.body.classList.remove("route-loading-indet");
  }
}
